import type { ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'secondary' | 'text' | 'danger';

const base =
  'inline-flex min-h-[44px] items-center justify-center gap-2 font-semibold text-[16px] tracking-[0.2px] transition-all duration-150 ease-in-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-blue disabled:cursor-not-allowed';

const variants: Record<Variant, string> = {
  primary:
    'rounded-pill bg-primary-blue px-8 py-3.5 text-text-inverse hover:bg-sky-blue active:bg-primary-blue-shade-30 active:scale-[0.98] disabled:bg-primary-blue-tint-60 disabled:text-white/70',
  secondary:
    'rounded-pill border-[1.5px] border-primary-blue bg-transparent px-8 py-3.5 text-primary-blue hover:bg-primary-blue hover:text-text-inverse active:bg-primary-blue-shade-30 disabled:border-primary-blue-tint-60 disabled:text-primary-blue-tint-60',
  text: 'gap-1.5 bg-transparent px-0 py-0 font-medium text-primary-blue hover:text-sky-blue',
  danger:
    'rounded-pill bg-red px-8 py-3.5 font-bold text-text-inverse hover:bg-red-shade-30 disabled:bg-red/50',
};

export function Button({
  variant = 'primary',
  className = '',
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant }) {
  return <button className={`${base} ${variants[variant]} ${className}`} aria-disabled={props.disabled} {...props} />;
}
